/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {CookieService} from "ngx-cookie-service";
import {CookieKeys} from "../constant/cookie-keys";

@Injectable({
    providedIn: 'root'
})
export class DynamiclinkService {

    private casPattern = /%CAS%/g;

    constructor(private cookieService: CookieService) {
    }

    /*
  * replace patterns
  */
    dynamize(url: string) {
        //cookie agreement
        var agreement = this.cookieService.get(CookieKeys.COOKIE_AGREEMENT);
        return url.replace(this.casPattern, agreement);
    }

}
